export default __webpack_public_path__ + "static/media/horizon.4336559e.webp";